module.exports = __webpack_public_path__ + "img/gather-2.b74f594f.png";